<template lang="pug">
  include ../../../pug/mixins/bem
  +b.input-group
    //- +e.item
    +e.item
      slot(name='customInput')              
        +e.INPUT.input(v-bind="$props", 
                      :value="value"
                      :class='{"input-group__input--error": errors.has(name)}'
                      @input="$emit('input',$event.target.value)")
      +e.LABEL.label(:for='id', :class="{'is-active-label': value }") {{ label }}
      +e.SPAN.error(v-show="errors.has(name)" ) {{ errors.first(name) }}

</template>
<script>

export default {
  name: "InputGroup",
  inject: ['$validator'],
  props: {
    className: {
      type: String,
      default: 'input-group'
    },
    type: {
      type: String,
      default: 'text'
    },
    id: String,
    name: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    value: [String, Number, Object],
    'v-validate': String,
    custom: false
  }
}
</script>




// WEBPACK FOOTER //
// src/js/shared/components/InputGroup.vue